// extracted by mini-css-extract-plugin
export default {"cls1":"Unibrow-cls1_S_u","cls2":"Unibrow-cls2_BfH Unibrow-cls1_S_u"};